import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageInitializer {
  constructor(private translateService: TranslateService) {}

  init(): Promise<void> {
    return new Promise((resolve) => {
      const savedLang = localStorage.getItem('lang');

      if (savedLang) {
          this.translateService.use(savedLang);
          localStorage.setItem('lang', savedLang); // Store the selected language

      } else {
        this.translateService.use('ar'); // Default language
        localStorage.setItem('lang', 'ar'); // Store the selected language

      }
      resolve();
    });
  }
}
